import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeProvider: String,
    cookieName: { type: String, default: "attribution_v2_active_tab" }
  }

  connect() {
    if (!this.activeProviderValue) {
      const urlProvider = new URLSearchParams(window.location.search).get("provider")
      const saved = this.getSavedTab()
      const validProviders = this.tabTargets.map(t => t.dataset.provider)

      if (urlProvider && validProviders.includes(urlProvider)) {
        this.activeProviderValue = urlProvider
      } else {
        this.activeProviderValue = (saved && validProviders.includes(saved)) ? saved : validProviders[0]
      }
    }
    this.updateTabs()
  }

  select(event) {
    event.preventDefault()
    const provider = event.currentTarget.dataset.provider
    if (provider === this.activeProviderValue) return

    this.activeProviderValue = provider
    this.saveTab(provider)
    this.updateTabs()
  }

  updateTabs() {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.provider === this.activeProviderValue)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.provider !== this.activeProviderValue)
    })
  }

  getSavedTab() {
    const name = this.cookieNameValue
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : null
  }

  saveTab(provider) {
    const name = this.cookieNameValue
    document.cookie = `${name}=${encodeURIComponent(provider)}; path=/; max-age=${60 * 60 * 24 * 365}`
  }
}
